<footer class="footer">
	<div class="footer__main">
		<!-- Columna izquierda: logo + contacto -->
		<div class="footer__brand">
			<a href="http://www.cajamorelia.com.mx" target="_blank">
				<img
					class="footer__logo"
					src="./assets/images/general/Logo_VCF.png"
					alt="Valladolid Caja Financiera" />
			</a>
			<address class="footer__contact">
				Acatita de Baján 222, Morelia, Mich.<br />
				Tel. 800 3000 268<br />
				atencionasocios@valladolidcaja.com
			</address>
		</div>

		<!-- Columna central: hashtag + redes sociales -->
		<div class="footer__center">
			<p class="footer__hashtag">
				<span class="footer__hashtag--white">#</span
				><span class="footer__hashtag--orange">SOMOS</span
				><span class="footer__hashtag--white">LA</span
				><span class="footer__hashtag--orange">CAJA</span
				><span class="footer__hashtag--white">QUE</span
				><span class="footer__hashtag--orange">VA</span>
				<span class="footer__hashtag--white">CONTIGO</span>
			</p>
			<cmv-social-media
				class="footer__social-media"
				color="#212529"></cmv-social-media>
		</div>

		<div class="footer__right">
			<div class="footer__authorized">
				<img
					src="./assets/images/icons/authorized_black.svg"
					alt="Autorizados por la CNBV" />
				<p>Autorizados por la <strong>CNBV</strong></p>
			</div>
			<p class="footer__webpage">
				Consulta costos y comisiones en<br />
				<a href="www.valladolidcaja.com" target="_blank"
					>www.valladolidcaja.com</a
				>
			</p>
		</div>
	</div>

	<!-- Barra inferior: texto legal -->
	<div class="footer__info">
		<p class="footer__message">
			Valladolid Servicios Financieros pertenece al grupo Caja Morelia
			Valladolid S.C. de A.P. de R.L. de C.V.
		</p>
		<span class="footer__version">v{{ version }}</span>
	</div>
</footer>
